"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
const event_manager_1 = __importDefault(require("./event-manager"));
const emitEvent = (event, payload) => {
    if (event_manager_1.default.mounted === true) {
        event_manager_1.default.emit(event, payload);
    }
};
const modal = Object.assign({
    renderModal: (type) => emitEvent(constants_1.ModalActions.RENDER_MODAL, type),
    remove: () => emitEvent(constants_1.ModalActions.REMOVE_MODAL),
    setContent: (content) => emitEvent(constants_1.ModalActions.SET_CONTENT, content),
    setAndRender: (type, component) => {
        emitEvent(constants_1.ModalActions.RENDER_MODAL, type);
        emitEvent(constants_1.ModalActions.SET_CONTENT, { [type]: component });
    }
});
event_manager_1.default
    .register(constants_1.ModalActions.DID_MOUNT, () => {
    event_manager_1.default.mounted = true;
})
    .register(constants_1.ModalActions.WILL_UNMOUNT, () => {
    event_manager_1.default.mounted = false;
});
exports.default = modal;
